export const DOBOX_RESOLVED_FILTER = {
  RESOLVED: 'resolved',
  UNRESOLVED: 'unresolved',
} as const;

export type DoboxResolvedFilter =
  (typeof DOBOX_RESOLVED_FILTER)[keyof typeof DOBOX_RESOLVED_FILTER];

export enum PendingActionType {
  DELETE = 'delete',
  RESOLVE = 'resolve',
  UNRESOLVE = 'unresolve',
}

export interface PendingAction {
  id: string;
  type: PendingActionType;
  entryId: string;
  createdAt: number;
  timerId: ReturnType<typeof setTimeout>;
}

export interface PendingActionsState {
  pendingActions: Map<string, PendingAction>;
  hiddenEntryIds: Set<string>;
}

export interface PendingActionsActions {
  addPendingAction: (action: PendingAction) => void;
  removePendingAction: (actionId: string) => void;
  /** Remove from the map and clear timer, and update hiddenEntryIds accordingly. */
  commitPendingAction: (actionId: string) => void;
  getPendingActionForEntry: (entryId: string) => PendingAction | undefined;
  clearAllPendingActions: () => Map<string, PendingAction>;
}

export type PendingActionsStore = PendingActionsState & PendingActionsActions;
